// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4ffe378","988":"28679bbf"}[chunkId] + ".chunk.js";
};